// Static icon imports - only import the specific icons used in the app
import type { ComponentType } from 'react'
import {
  RiHomeSmileLine,
  RiMailSendLine,
  RiDeleteBin2Line,
  RiDragMove2Fill,
  RiDragDropLine,
  RiTodoLine,
  RiFileList3Line,
} from 'react-icons/ri'
import {
  BsPerson,
  BsCart2,
  BsMusicNoteBeamed,
  BsArrowDownCircleFill,
  BsArrowBarRight,
  BsArrowBarLeft,
  BsPcDisplayHorizontal,
} from 'react-icons/bs'
import {
  IoMdImages,
  IoMdAdd,
  IoMdCheckmarkCircleOutline,
  IoMdColorPalette,
} from 'react-icons/io'
import {
  BiChat,
  BiChevronsUp,
  BiChevronsDown,
  BiReset,
  BiSelectMultiple,
  BiSolidColorFill,
  BiChevronsLeft,
  BiChevronsRight,
  BiChevronLeft,
  BiChevronRight,
  BiChevronDown,
  BiChevronUp,
  BiPlus,
  BiUndo,
  BiRedo,
  BiBookHeart,
} from 'react-icons/bi'
import { CgSearch, CgUndo } from 'react-icons/cg'
import {
  IoSettingsSharp,
  IoPersonCircleSharp,
  IoCopyOutline,
  IoStopCircleOutline,
  IoPlayCircleOutline,
} from 'react-icons/io5'
import {
  HiOutlineDotsHorizontal,
  HiDotsHorizontal,
  HiDotsCircleHorizontal,
  HiMenu,
} from 'react-icons/hi'
import { HiMiniSparkles, HiArrowsPointingOut } from 'react-icons/hi2'
import { TfiLineDashed } from 'react-icons/tfi'
import {
  FaAnglesUp,
  FaCar,
  FaGears,
  FaHouse,
  FaLightbulb,
  FaMagnifyingGlass,
  FaPencil,
  FaTriangleExclamation,
  FaAnglesLeft,
  FaAnglesRight,
} from 'react-icons/fa6'
import {
  MdLightMode,
  MdDarkMode,
  Md123,
  MdAbc,
  MdInsertEmoticon,
  MdDragIndicator,
  MdOutlineDragIndicator,
  MdWork,
  MdOutlineQuiz,
  MdMoveUp,
  MdMoveDown,
  MdSave,
  MdContentCopy,
  MdLocationOn,
  MdOutlineFilter3,
  MdOutlineFilter4,
  MdOutlineFilter5,
  MdOutlineFilter6,
  MdOutlineFilter7,
  MdOutlineFilter8,
  MdOutlineFilter9,
  MdOutlineFilter9Plus,
  MdOutlineSettingsBackupRestore,
  MdDriveFileRenameOutline,
  MdHideSource,
  MdInvertColors,
  MdInvertColorsOff,
  MdOutlineCircle,
  MdBubbleChart,
} from 'react-icons/md'
import {
  LuCirclePlus,
  LuArrowRightFromLine,
  LuArrowLeftFromLine,
  LuSquareDashed,
  LuLaptopMinimalCheck,
} from 'react-icons/lu'
import { LiaUndoAltSolid, LiaNewspaperSolid } from 'react-icons/lia'
import {
  PiImage,
  PiDownloadSimpleFill,
  PiResizeLight,
  PiMouseScroll,
} from 'react-icons/pi'
import {
  FaAnchor,
  FaAppleAlt,
  FaStar,
  FaStoreAlt,
  FaWordpress,
  FaReact,
  FaNodeJs,
  FaBicycle,
  FaBell,
  FaBolt,
  FaCat,
  FaDice,
  FaDog,
  FaDove,
  FaEdit,
  FaEnvelope,
  FaFan,
  FaFeather,
  FaFish,
  FaHammer,
  FaHandshake,
  FaHatCowboy,
  FaHatWizard,
  FaHeadphones,
  FaHeart,
  FaHorse,
  FaIceCream,
  FaKey,
  FaKeyboard,
  FaLandmark,
  FaLeaf,
  FaMoon,
  FaMountain,
  FaMusic,
  FaPalette,
  FaPaperclip,
  FaPaperPlane,
  FaPizzaSlice,
  FaPlane,
  FaPlusCircle,
  FaRegCheckCircle,
  FaRegHourglass,
  FaRocket,
  FaRobot,
  FaSeedling,
  FaSnowman,
  FaSun,
  FaHourglassStart,
  FaArrowLeft,
  FaArrowRight,
  FaTimes,
  FaRandom,
  FaList,
  FaPlus,
  FaRegClone,
  FaSave,
  FaUmbrellaBeach,
  FaUser,
} from 'react-icons/fa'
import { TiDeleteOutline, TiShoppingCart } from 'react-icons/ti'
import { AiOutlineEdit, AiOutlineForm, AiFillEdit } from 'react-icons/ai'
import {
  TbCancel,
  TbLayoutNavbar,
  TbCircleDashed,
  TbBlob,
} from 'react-icons/tb'
import {
  ImImages,
  ImBlocked,
  ImEyeBlocked,
  ImEnlarge2,
  ImShrink2,
  ImCamera,
} from 'react-icons/im'
import { GrGraphQl } from 'react-icons/gr'
import { GiAbstract019, GiComb, GiSpellBook } from 'react-icons/gi'
import { SiSvgtrace } from 'react-icons/si'
import {
  GoArrowLeft,
  GoArrowRight,
  GoTriangleDown,
  GoTriangleUp,
} from 'react-icons/go'
import { VscSparkleFilled } from 'react-icons/vsc'

export type IconLibrariesShape = Record<
  string,
  Record<string, ComponentType<Record<string, unknown>>>
>

export const iconLibraries = {
  ri: {
    RiHomeSmileLine,
    RiMailSendLine,
    RiDeleteBin2Line,
    RiDragMove2Fill,
    RiDragDropLine,
    RiTodoLine,
    RiFileList3Line,
  },
  bs: {
    BsPerson,
    BsCart2,
    BsMusicNoteBeamed,
    BsArrowDownCircleFill,
    BsArrowBarRight,
    BsArrowBarLeft,
    BsPcDisplayHorizontal,
  },
  bi: {
    BiChat,
    BiChevronsUp,
    BiChevronsDown,
    BiReset,
    BiSelectMultiple,
    BiSolidColorFill,
    BiChevronsLeft,
    BiChevronsRight,
    BiChevronLeft,
    BiChevronRight,
    BiChevronDown,
    BiChevronUp,
    BiPlus,
    BiUndo,
    BiRedo,
    BiBookHeart,
  },
  cg: {
    CgSearch,
    CgUndo,
  },
  io: {
    IoMdImages,
    IoMdAdd,
    IoMdCheckmarkCircleOutline,
    IoMdColorPalette,
  },
  io5: {
    IoSettingsSharp,
    IoPersonCircleSharp,
    IoCopyOutline,
    IoStopCircleOutline,
    IoPlayCircleOutline,
  },
  hi: {
    HiOutlineDotsHorizontal,
    HiDotsHorizontal,
    HiDotsCircleHorizontal,
    HiMenu,
  },
  hi2: {
    HiMiniSparkles,
    HiArrowsPointingOut,
  },
  tfi: {
    TfiLineDashed,
  },
  fa: {
    FaAnchor,
    FaAppleAlt,
    FaStar,
    FaStoreAlt,
    FaWordpress,
    FaReact,
    FaNodeJs,
    FaBicycle,
    FaBell,
    FaBolt,
    FaCat,
    FaDice,
    FaDog,
    FaDove,
    FaEdit,
    FaEnvelope,
    FaFan,
    FaFeather,
    FaFish,
    FaHammer,
    FaHandshake,
    FaHatCowboy,
    FaHatWizard,
    FaHeadphones,
    FaHeart,
    FaHorse,
    FaIceCream,
    FaKey,
    FaKeyboard,
    FaLandmark,
    FaLeaf,
    FaMoon,
    FaMountain,
    FaMusic,
    FaPalette,
    FaPaperclip,
    FaPaperPlane,
    FaPizzaSlice,
    FaPlane,
    FaPlusCircle,
    FaRegCheckCircle,
    FaRegHourglass,
    FaRocket,
    FaRobot,
    FaSeedling,
    FaSnowman,
    FaSun,
    FaHourglassStart,
    FaArrowLeft,
    FaArrowRight,
    FaTimes,
    FaRandom,
    FaList,
    FaPlus,
    FaRegClone,
    FaSave,
    FaUmbrellaBeach,
    FaUser,
  },
  fa6: {
    FaAnglesUp,
    FaCar,
    FaGears,
    FaHouse,
    FaLightbulb,
    FaMagnifyingGlass,
    FaPencil,
    FaTriangleExclamation,
    FaAnglesLeft,
    FaAnglesRight,
  },
  md: {
    MdLightMode,
    MdDarkMode,
    Md123,
    MdAbc,
    MdInsertEmoticon,
    MdDragIndicator,
    MdOutlineDragIndicator,
    MdWork,
    MdOutlineQuiz,
    MdMoveUp,
    MdMoveDown,
    MdSave,
    MdContentCopy,
    MdLocationOn,
    MdOutlineFilter3,
    MdOutlineFilter4,
    MdOutlineFilter5,
    MdOutlineFilter6,
    MdOutlineFilter7,
    MdOutlineFilter8,
    MdOutlineFilter9,
    MdOutlineFilter9Plus,
    MdOutlineSettingsBackupRestore,
    MdDriveFileRenameOutline,
    MdHideSource,
    MdInvertColors,
    MdInvertColorsOff,
    MdOutlineCircle,
    MdBubbleChart,
  },
  lu: {
    LuCirclePlus,
    LuArrowRightFromLine,
    LuArrowLeftFromLine,
    LuSquareDashed,
    LuLaptopMinimalCheck,
  },
  lia: {
    LiaUndoAltSolid,
    LiaNewspaperSolid,
  },
  pi: {
    PiImage,
    PiDownloadSimpleFill,
    PiResizeLight,
    PiMouseScroll,
  },
  ti: {
    TiDeleteOutline,
    TiShoppingCart,
  },
  ai: {
    AiOutlineEdit,
    AiOutlineForm,
    AiFillEdit,
  },
  tb: {
    TbCancel,
    TbLayoutNavbar,
    TbCircleDashed,
    TbBlob,
  },
  im: {
    ImImages,
    ImBlocked,
    ImEyeBlocked,
    ImEnlarge2,
    ImShrink2,
    ImCamera,
  },
  gr: {
    GrGraphQl,
  },
  gi: {
    GiAbstract019,
    GiComb,
    GiSpellBook,
  },
  si: {
    SiSvgtrace,
  },
  go: {
    GoArrowLeft,
    GoArrowRight,
    GoTriangleDown,
    GoTriangleUp,
  },
  vsc: {
    VscSparkleFilled,
  },
} as const satisfies IconLibrariesShape
